// extracted by mini-css-extract-plugin
module.exports = {"popover":"src-components-app-header-notifications-Notifications-module__popover--3V7GU"};